import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import articlePage from "@faire/web-api--source/routes/support/articles/articleId";

import { InstantAnswerContext, InstantAnswerScenario } from "../../types";

import { getVerifyAccountCTA } from "./shared";

export const WhyOrderOnHoldIA: InstantAnswerBuilderFn = (
  strictLocalize,
  articles
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getVerifyAccountCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getVerifyAccountCTA(context, strictLocalize)?.getLink?.();
      },
    },
    learnMoreLink: articles?.MyOrders.BUSINESS_PROFILE
      ? articlePage(articles.MyOrders.BUSINESS_PROFILE.id)
      : undefined,
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => VERIFY_YOUR_ACCOUNT(strictLocalize),
    getDescription: () => [
      WE_NEED_MORE_INFO_TO_VERIFY_YOUR_ACCOUNT(strictLocalize),
      WE_WILL_REVIEW_YOUR_INFO(strictLocalize),
    ],
  };
};

const VERIFY_YOUR_ACCOUNT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Verify your account to complete your order",
    description: {
      text: "Title for the answer of Why is my order on hold issue",
    },
  });

const WE_NEED_MORE_INFO_TO_VERIFY_YOUR_ACCOUNT = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "We want you to get your order as soon as possible. We just need some more information to verify your account — you’ll only need to do this once.",
  });

const WE_WILL_REVIEW_YOUR_INFO = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "As soon as we receive your info, we’ll review it. We typically respond within 1 business day.",
  });
